import React from 'react';

import { useHistory } from "react-router";
import { getIndexPresence } from "api/urls";
import queryString from 'query-string'

import IndexPresenceContainer from 'components/wrapper/IndexPresenceContainer';

const IndexPresence = (props) => {

    const history = useHistory()
    const parsed = queryString.parse(history.location.search);

    return (
        <div  {...props}>
            <IndexPresenceContainer
                url={getIndexPresence(parsed.company__symbol)}
                title={"Index Presence"}
            />
        </div>
    )
};

export default (IndexPresence);
